import { mapGetters, mapActions } from 'vuex'
export default {
  data () {
    return {
      localService: {
        name: '',
        short_name: '',
        parent_id: undefined,
        icon: null,
        description: '',
        priority: 0
      },
      rules: {
        'name': [
          { required: true, message: 'Tên không thể để trống', trigger: 'change' },
          { min: 5, max: 255, message: 'Tên phải chứa từ 5 đến 255 ký tự', trigger: 'change' }
        ],
        'short_name': [
          { required: true, message: 'Bạn chưa nhập tên viết tắt', trigger: 'change' },
          { min: 2, max: 255, message: 'Tên phải chứa từ 2 đến 255 ký tự', trigger: 'change' }
        ]
      },
      submitting: false
    }
  },
  computed: {
    ...mapGetters('service', ['services'])
  },
  methods: {
    ...mapActions('service', ['getAllServices']),
    newService () {
      this.localService = {
        name: '',
        short_name: '',
        parent_id: undefined,
        icon: null,
        description: '',
        priority: 0
      }
    }
  },
  mounted () {
    this.newService()
    if (!this.services.length) {
      this.getAllServices({limit: -1})
    }
  },
  watch: {
    localService: {
      handler: function (value) {
        if (this.watching) {
          this.changedData = true
        }
      },
      deep: true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/service/mixins/index.js